import React from "react";
import { cn } from "./utils";

export default function Textarea({ className = "", invalid = false, rows = 3, ...props }) {
  return (
    <textarea
      rows={rows}
      className={cn(
        "w-full rounded-sm border bg-white px-3 py-2 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:border-slate-500",
        invalid ? "border-rose-400" : "border-slate-300",
        className
      )}
      {...props}
    />
  );
}
